import React, { useState } from 'react';
import {
  Checkbox,
  VStack as ChakraVStack,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverHeader,
  PopoverCloseButton,
  Input,
  Divider,
  Box,
  Button,
  Badge,
  VStack,
  Text,
} from '@chakra-ui/react';
import { RiFilter3Line } from 'react-icons/ri';
import { useData } from '../../data';

const CountryFilter = ({
  selectedCountries,
  setSelectedCountries,
  setPage,
}) => {
  const [searchCountry, setSearchCountry] = useState('');

  // Fetch countries/locations data
  const { data: countriesData } = useData('experts/locations');
  const countriesList = countriesData?.data?.locations || [];

  const handleCountryToggle = (country) => {
    setSelectedCountries((prev) => {
      if (prev.includes(country)) {
        return prev.filter((id) => id !== country);
      } else {
        return [...prev, country];
      }
    });
    setPage(1);
  };

  // Handle country search
  const filteredCountries = countriesList.filter((country) =>
    country.title.toLowerCase().includes(searchCountry.toLowerCase()),
  );

  // Clear all filters
  const clearFilters = () => {
    setSelectedCountries([]);
    setSearchCountry('');
    setPage(1);
  };

  return (
    <>
      {/* Country Filter */}
      <Popover placement="bottom-start">
        <PopoverTrigger>
          <Button
            leftIcon={<RiFilter3Line />}
            variant="outline"
            size="md"
            bg="white"
            borderColor={selectedCountries.length > 0 ? '#134A70' : 'gray.300'}
            color={selectedCountries.length > 0 ? '#134A70' : 'gray.700'}
            fontWeight="medium"
            _hover={{ borderColor: '#134A70' }}
            _focus={{
              borderColor: '#134A70',
              boxShadow: '0 0 0 1px #134A70',
            }}
            className="md:text-sm text-xs"
          >
            Filter by Country
            {selectedCountries.length > 0 && (
              <Badge
                ml={2}
                colorScheme="blue"
                variant="solid"
                borderRadius="full"
                fontSize="xs"
              >
                {selectedCountries.length}
              </Badge>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent
          w="300px"
          maxH="400px"
          overflow="hidden"
          boxShadow="lg"
          borderColor="gray.200"
        >
          <PopoverHeader
            fontWeight="semibold"
            borderBottom="1px solid"
            borderColor="gray.200"
            pb={2}
          >
            Filter by Country
          </PopoverHeader>
          <PopoverCloseButton />
          <PopoverBody p={0}>
            <VStack spacing={0} align="stretch" maxH="350px" overflow="hidden">
              {/* Search Input */}
              <Box p={3} borderBottom="1px solid" borderColor="gray.100">
                <Input
                  placeholder="Search countries..."
                  value={searchCountry}
                  onChange={(e) => setSearchCountry(e.target.value)}
                  size="sm"
                  borderColor="gray.300"
                  _focus={{
                    borderColor: '#134A70',
                    boxShadow: '0 0 0 1px #134A70',
                  }}
                />
              </Box>

              {/* Countries List */}
              <Box overflowY="auto" maxH="250px">
                <ChakraVStack spacing={0} align="stretch">
                  {filteredCountries.length > 0 ? (
                    filteredCountries.map((country) => (
                      <Box
                        key={country.id}
                        p={3}
                        borderBottom="1px solid"
                        borderColor="gray.100"
                        _hover={{ bg: 'gray.50' }}
                        cursor="pointer"
                        onClick={() => handleCountryToggle(country.title)}
                      >
                        <Checkbox
                          isChecked={selectedCountries.includes(country.title)}
                          onChange={() => handleCountryToggle(country.title)}
                          colorScheme="blue"
                          size="md"
                        >
                          <Text fontSize="sm" ml={2}>
                            {country.title}
                          </Text>
                        </Checkbox>
                      </Box>
                    ))
                  ) : (
                    <Box p={3} textAlign="center">
                      <Text fontSize="sm" color="gray.500">
                        No countries found
                      </Text>
                    </Box>
                  )}
                </ChakraVStack>
              </Box>

              {/* Clear Filters Button */}
              {selectedCountries.length > 0 && (
                <>
                  <Divider />
                  <Box p={3}>
                    <Button
                      size="sm"
                      variant="ghost"
                      colorScheme="blue"
                      onClick={clearFilters}
                      w="full"
                    >
                      Clear Filters
                    </Button>
                  </Box>
                </>
              )}
            </VStack>
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </>
  );
};

export default CountryFilter;
